import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { AthleteProfileShell } from '../components/ProfileShell';
import Button from '../components/Button';

// Each platform's brand glyph + form-field key. Rendered uniformly in a
// 2-up grid below — keeping the data here avoids the 200 lines of
// hand-written rows the page used to carry.
const SOCIAL_PLATFORMS = [
  { key: 'youtube_handle',   label: 'YouTube',     placeholder: 'Channel URL or @handle', color: '#FF0000',
    path: 'M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' },
  { key: 'tiktok_handle',    label: 'TikTok',      placeholder: '@username', color: '#000000',
    path: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z' },
  { key: 'twitter_handle',   label: 'X / Twitter', placeholder: '@username', color: '#1da1f2',
    path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
  { key: 'instagram_handle', label: 'Instagram',   placeholder: '@username', color: '#E1306C',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' },
  { key: 'snapchat_handle',  label: 'Snapchat',    placeholder: '@username', color: '#FFFC00',
    path: 'M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.08.341-.12.517-.12.37 0 .722.18.939.464.276.351.357.817.199 1.246-.295.82-1.32 1.258-2.017 1.447-.137.037-.27.075-.38.116-.165.06-.224.182-.224.313 0 .107.061.2.166.274.122.086.25.147.389.195.67.232 1.34.66 1.503 1.233.095.333.075.639-.06.886-.302.555-1.164.894-2.568.894-.327 0-.677-.023-1.044-.067-.225-.027-.45-.045-.664-.045-.358 0-.628.06-.87.225-.37.252-.737.495-1.72.495-.23 0-.46-.023-.69-.069-.45-.09-.9-.135-1.35-.135-.45 0-.9.045-1.35.135-.23.046-.46.069-.69.069-.984 0-1.351-.243-1.72-.495-.242-.165-.512-.225-.87-.225-.214 0-.44.018-.664.045-.367.044-.717.067-1.044.067-1.404 0-2.266-.339-2.568-.894-.135-.247-.155-.553-.06-.886.163-.573.833-1.001 1.503-1.233.139-.048.267-.109.389-.195.105-.074.166-.167.166-.274 0-.131-.059-.253-.224-.313-.11-.041-.243-.079-.38-.116-.697-.189-1.722-.627-2.017-1.447-.158-.429-.077-.895.199-1.246.217-.284.569-.464.939-.464.176 0 .352.04.517.12.374.181.733.317 1.033.301.198 0 .326-.045.401-.09-.008-.165-.018-.33-.03-.51l-.003-.06c-.104-1.628-.23-3.654.299-4.847C7.653 1.069 11.009.793 12 .793h.206z' },
  { key: 'facebook_handle',  label: 'Facebook',    placeholder: 'Profile URL or username', color: '#1877F2',
    path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
  { key: 'linkedin_handle',  label: 'LinkedIn',    placeholder: 'Profile URL or username', color: '#0A66C2',
    path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
  { key: 'whatsapp_number',  label: 'WhatsApp',    placeholder: 'Phone number or @handle', color: '#25D366',
    path: 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.273.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z' },
];

export default function SocialPage() {
  const { user, API_URL } = useAuth();
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const [handles, setHandles] = useState(() =>
    Object.fromEntries(SOCIAL_PLATFORMS.map(p => [p.key, '']))
  );
  const [personalStatement, setPersonalStatement] = useState('');
  const [profileUrl, setProfileUrl] = useState('');
  const [previewModal, setPreviewModal] = useState(null);

  const getAxiosConfig = () => ({
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') setPreviewModal(null); };
    if (previewModal) document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [previewModal]);

  const fetchProfile = async () => {
    try {
      const response = await axios.get(`${API_URL}/athletes/profile`, getAxiosConfig());
      if (response.data) {
        setHandles(Object.fromEntries(
          SOCIAL_PLATFORMS.map(p => [p.key, response.data[p.key] || ''])
        ));
        setPersonalStatement(response.data.personal_statement || '');
        setProfileUrl(response.data.profile_url || '');
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  const saveField = async (name, value) => {
    try {
      await axios.post(
        `${API_URL}/athletes/profile`,
        { [name]: value },
        getAxiosConfig()
      );
      setMessage('Saved');
      setMessageType('');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Auto-save error:', error);
      setMessage('Error saving');
      setMessageType('error');
      setTimeout(() => setMessage(''), 4000);
    }
  };

  return (
    <AthleteProfileShell activeTab="Social">
      {message && (
        <div className={`settings-toast ${messageType === 'error' ? 'settings-toast--error' : ''}`} role="alert">{message}</div>
      )}

      {/* Personal Statement */}
      <div className="settings-section">
        <h2 className="settings-section__title">Personal Statement</h2>
        <p className="settings-section__desc">Share your story with coaches. A personal statement can set you apart.</p>
        <div className="form-field">
          <textarea
            id="personal_statement"
            value={personalStatement}
            onChange={(e) => setPersonalStatement(e.target.value.slice(0, 280))}
            onBlur={() => saveField('personal_statement', personalStatement)}
            className="form-field__input"
            rows={5}
            maxLength={280}
            placeholder="Tell coaches about yourself, your goals, and what makes you unique..."
          />
          <div style={{ marginTop: '4px', fontSize: '12px', color: 'var(--ed-on-light-subtle)', textAlign: 'right' }}>
            {personalStatement.length} / 280 characters
          </div>
        </div>
      </div>

      {/* Social Media */}
      <div className="settings-section">
        <h2 className="settings-section__title">Social Media</h2>
        <p className="settings-section__desc">Your social media handles visible to coaches.</p>
        <div className="form-row" style={{ flexWrap: 'wrap' }}>
          {SOCIAL_PLATFORMS.map(p => {
            const id = `social_${p.key}`;
            const value = handles[p.key] || '';
            return (
              <div className="form-field" key={p.key} style={{ flex: '1 1 280px', minWidth: '240px' }}>
                <label className="form-field__label" htmlFor={id} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill={p.color}><path d={p.path}/></svg>
                  {p.label}
                </label>
                <input
                  id={id}
                  type="text"
                  value={value}
                  onChange={(e) => setHandles(prev => ({ ...prev, [p.key]: e.target.value }))}
                  onBlur={() => saveField(p.key, value)}
                  className="form-field__input"
                  placeholder={p.placeholder}
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* Preview Modal */}
      {previewModal && (
        <div className="modal-overlay" role="dialog" aria-modal="true" onClick={() => setPreviewModal(null)}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ position: 'relative', width: '90vw', height: '90vh', backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden' }}
            onClick={(e) => e.stopPropagation()}>
            <Button
              onClick={() => setPreviewModal(null)}
              aria-label="Close preview"
              variant="secondary"
              iconOnly
              style={{
                position: 'absolute', top: '12px', right: '12px', zIndex: 10
              }}
            >
              &times;
            </Button>
            <iframe
              src={previewModal === 'card'
                ? `/athlete/${user?.uid || '0'}/${profileUrl}/card`
                : `/athlete/${user?.uid || '0'}/${profileUrl}`}
              title={previewModal === 'card' ? 'Player Card Preview' : 'Public Profile Preview'}
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          </div>
        </div>
      )}
    </AthleteProfileShell>
  );
}
